import { persistentFiltersReducer } from "./reducers/persistentFiltersReducer";
import { stockStatusTableFiltersReducer } from "./reducers/stockStatusTableFiltersReducer";
import { stockStatusFiltersReducer } from "./reducers/stockStatusFiltersReducer";
import { resourceEditFiltersReducer } from "./reducers/resourceEditFiltersReducer";
import { translationsMaterialsReducer } from "./reducers/translationsMaterialsReducer";

import type { PayloadAction } from "./types";
import type {
    StockStatusTableFiltersState,
    SetStockStatusTableFiltersAction,
} from "./reducers/stockStatusTableFiltersReducer";
import type { SubcontractingModalState } from "./types";
import type { PersistentFiltersState, SetPersistentFiltersAction } from "./reducers/persistentFiltersReducer";
import type { TranslationsMaterialsState, TranslationsMaterialsActions } from "./reducers/translationsMaterialsReducer";
import type { StockStatusFiltersState, SetStockStatusFiltersAction } from "./reducers/stockStatusFiltersReducer";
import type { ResourceEditFiltersState, SetResourceEditFiltersAction } from "./reducers/resourceEditFiltersReducer";

export const SET_SUBCONTTRACTING_MODAL_ACTION_NAME = "set_subcontracting_modal";
export const RESET_SUBCONTTRACTING_MODAL_ACTION_NAME = "reset_subcontracting_modal";
export type SetSubcontractingModalAction = PayloadAction<
    typeof SET_SUBCONTTRACTING_MODAL_ACTION_NAME,
    SubcontractingModalState
>;
export type ResetSubcontractingModalAction = PayloadAction<
    typeof RESET_SUBCONTTRACTING_MODAL_ACTION_NAME,
    typeof undefined
>;

export type ActionTypes =
    | SetSubcontractingModalAction
    | ResetSubcontractingModalAction
    | SetPersistentFiltersAction
    | SetStockStatusTableFiltersAction
    | SetStockStatusFiltersAction
    | SetResourceEditFiltersAction
    | TranslationsMaterialsActions;

const initialStockStatusSubcontractingModal: SubcontractingModalState = {
    show: false,
    external_operation_id: "",
    quantity_total: "",
};

const initialState = {
    subcontracting_modal: initialStockStatusSubcontractingModal,
};

const subcontractingModalReducer = (
    state = initialState.subcontracting_modal,
    action: SetSubcontractingModalAction | ResetSubcontractingModalAction
) => {
    let new_state = state;

    switch (action.type) {
        case SET_SUBCONTTRACTING_MODAL_ACTION_NAME:
            new_state = { ...state, ...action.data };
            break;
        case RESET_SUBCONTTRACTING_MODAL_ACTION_NAME:
            new_state = initialState.subcontracting_modal;
            break;
        default:
            break;
    }

    return new_state;
};

export type ActionReduxState = {
    subcontracting_modal: (
        state: SubcontractingModalState | undefined,
        action: SetSubcontractingModalAction | ResetSubcontractingModalAction
    ) => SubcontractingModalState;
    stock_status_filters: (
        state: StockStatusFiltersState,
        action: SetStockStatusFiltersAction
    ) => StockStatusFiltersState;
    resource_edit_filters: (
        state: ResourceEditFiltersState,
        action: SetResourceEditFiltersAction
    ) => ResourceEditFiltersState;
    stock_status_table_filters: (
        state: StockStatusTableFiltersState,
        action: SetStockStatusTableFiltersAction
    ) => StockStatusTableFiltersState;
    persistent_filters: (state: PersistentFiltersState, action: SetPersistentFiltersAction) => PersistentFiltersState;
    translations_materials: (
        state: TranslationsMaterialsState,
        action: TranslationsMaterialsActions
    ) => TranslationsMaterialsState;
};

export type ReduxState = {
    subcontracting_modal: SubcontractingModalState;
    stock_status_filters: StockStatusFiltersState;
    resource_edit_filters: ResourceEditFiltersState;
    stock_status_table_filters: StockStatusTableFiltersState;
    persistent_filters: PersistentFiltersState;
    translations_materials: TranslationsMaterialsState;
};

export const reducers: ActionReduxState = {
    stock_status_filters: stockStatusFiltersReducer,
    resource_edit_filters: resourceEditFiltersReducer,
    stock_status_table_filters: stockStatusTableFiltersReducer,
    persistent_filters: persistentFiltersReducer,
    subcontracting_modal: subcontractingModalReducer,
    translations_materials: translationsMaterialsReducer,
};
